import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

class HeaderComponent extends Component {
  isAuthenticated = false;
  username = '';

  constructor(props) {
    super(props);
    if (localStorage.getItem('access_token')) {
      this.isAuthenticated = true
      this.username = localStorage.getItem('username')
    }
  }

  shouldComponentUpdate(prevProps, nextState) {
    if (prevProps !== this.props) {
      if (localStorage.getItem('access_token')) {
        this.isAuthenticated = true
        this.username = localStorage.getItem('username')
      }
      return true
    }
    return false

  }

  componentDidUpdate(prevProps) {
    if (localStorage.getItem('access_token')) {
      this.isAuthenticated = true
      this.username = localStorage.getItem('username')
    }
  }


  render() {
    const path = this.props.location.pathname.slice(1);
    if (path === '') {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('homePage');
    } else {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('homePage');
    }

    return (
      <header className={(path === '') ? 'home-page' : 'inner-page'} >

      </header>
    )
  }
}

const mapStateToProps = state => {
  return {
    result: state.loginRequest && state.loginRequest.result
  }
}
export default connect(mapStateToProps, null)(withRouter(HeaderComponent))
